import { createSelector } from '@reduxjs/toolkit';

const getSnack = ({ snackbar }) => snackbar;

export const snackbarSelector = createSelector([getSnack], ({ message, snackType }) => ({
  snackMessage: message,
  snackType
}));
